<template>
  <div class="menu-item">
        <router-link class="primary-a" :to="{ name: item.route, params: item.params }">
            <div class="menu-primary" v-bind:class="{ 'menu-primary-active':active }">
                    <span>{{item.label}}</span>
                    <i class="fa fa-angle-down" aria-hidden="true" v-if="item.items.length > 0"></i>
            </div>
        </router-link>
        <div class="menu-secondary" v-if="item.items.length > 0">
            <router-link class="secondary-a" v-for="(subitem, index) in item.items" v-bind:key="index" :to="{ name: subitem.route, params: subitem.params }">
                <div class="menu-secondary-item" v-bind:class="{ 'secondary-a-active': $route.name == subitem.route }">
                        <span>{{subitem.label}}</span>
                </div>
            </router-link>
        </div>
  </div>
</template>

<script>
export default {
    name: 'menu-item',
    data(){
        return{
            active: false
        }
    },
    props:{
        item: Object
    },
    watch:{
        $route(){
            let currentRoute = this.$route.name ? this.$route.name : 'Home';
            this.active = currentRoute == this.item.route || this.subrouteActive(currentRoute);
        }
    },
    methods:{
        subrouteActive(route){
            let find = false;
            this.item.items.forEach(element => {
                if(element.route == route)
                    find = true;
            });
            return find;
        }
    }
}
</script>

<style lang="scss">
    @import '@/styles/General.scss';
    .menu-item{
        position: relative;
        display: inline-block;
        padding: 8px .3vw;
        margin-top: 12px; 
        margin-bottom: 12px; 
        font-size: 16px;
        height: fit-content;
        a.primary-a{
            text-decoration: none;
            color:black;
        }
        .menu-primary{
            font-weight: 350;
            padding: 0 12px;
            text-align: center;
            i{
                margin-left: 8px;
            }
        }
        .menu-primary-active{
            a.primary-a{
                text-decoration: none;
            }
            color: $red_primary;
            font-weight: 400;
            cursor: pointer;
            border-bottom: 2px solid $red_primary;
        }
        .menu-secondary{
            display: none;
            position: absolute;
            width: 100%;
            min-width: max-content;
            z-index: 1;
            padding: 12px 14px;
            margin-top: 9px;
            box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
            background-color: white;
            .menu-secondary-item{
                font-weight: 350;
                margin-bottom: 6px;
            }
            a.secondary-a{
                text-decoration: none;
                color:black;
            }
            .secondary-a:hover{
                text-decoration: none;
                color: $red_primary;
                font-weight: 400;
            }
            .secondary-a-active{
                text-decoration: none;
                color: $red_primary;
                font-weight: 400;
            }
            .menu-secondary-item:hover{
                a{
                    text-decoration: none;
                    color: $red_primary;
                }
                font-weight: 400;
            }
        }
    }
    
    .menu-item:hover{
        cursor: pointer;
        a.primary-a{
            text-decoration: none;
            color: $red_primary;
        }
        .menu-primary{
            font-weight: 400;
            border-bottom: 2px solid $red_primary;
        }
        .menu-secondary{
            display: block
        }
    }    
</style>